import { Navigate, useParams } from "react-router-dom";
import { CopyButton } from "../components/CopyButton";
import { LastUpdated } from "../components/LastUpdated";
import { PageHeader } from "../components/PageHeader";
import { StatusBadge } from "../components/StatusBadge";
import { WarningCallout } from "../components/WarningCallout";
import { languageLabels } from "../data/categories";
import { projectWordings } from "../data/projectLanguage";

export function WordingDetailsPage() {
  const { wordingId } = useParams();
  const wording = projectWordings.find((item) => item.id === wordingId);
  if (!wording) return <Navigate to="/wording" replace />;

  return (
    <div className="page page--narrow">
      <PageHeader eyebrow="Готовая формулировка" title={wording.title} description={`Язык: ${languageLabels[wording.language]}`} back />
      <article className="wording-detail">
        <div className="detail-card__badges"><StatusBadge status={wording.status} /></div>
        <blockquote>{wording.text}</blockquote>
        <dl className="details-list">
          <div><dt>Аудитория</dt><dd>{wording.audience}</dd></div>
          <div><dt>Где использовать</dt><dd>{wording.usageNote ?? "Без дополнительных ограничений"}</dd></div>
        </dl>
        {wording.status !== "approved" && (
          <WarningCallout title={wording.status === "draft" ? "Черновик" : "Требует проверки"}>
            Перед внешним использованием подтвердите актуальность текста.
          </WarningCallout>
        )}
        <LastUpdated date={wording.lastUpdatedAt} />
        <CopyButton text={wording.text} label="Скопировать формулировку" />
      </article>
    </div>
  );
}
